import React, { useCallback, useState } from "react";
import ParticlesAuth from "./ParticlesAuth";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  NavLink,
  Row,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import logoLight from "../../../assets/logo07-light.png";
import { Field, Formik } from "formik";
import { useDispatch } from "react-redux";
import { Routes } from "../../../constants/Routes";
import { useHistory } from "react-router-dom";
import LanguageDropdown from "../../common/LanguageDropdown";
import { useI18n } from "../../../i18n/I18nContext";
import {
  setAuthDate,
  setRefreshToken,
  setToken,
  setTokenTime,
} from "../../../reducers/AuthReducer";
import { useAuthContext } from "../../../api/auth/AuthContext";
import { toast } from "react-toastify";

const initialValues = {
  username: "998911234567",
  password: "password",
};

function LoginPage() {
  const dispatch = useDispatch();
  const { translate } = useI18n();
  const { AuthApi } = useAuthContext();
  const [showPassword, setShowPassword] = useState(false);
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);

  const validationSchema = (translate: any) =>
    Yup.object().shape({
      username: Yup.string().nullable().required(translate("TITTLE_REQUIRED")),
      password: Yup.string().nullable().required(translate("TITTLE_REQUIRED")),
    });
  const handleAuth = useCallback(
    (value: any) => {
      setLoading(true);
      AuthApi.getToken({
        password: value.password,
        username: value.username,
      })
        .then((res) => {
          if (res) {
            const token = res.access_token;
            const refreshToken = res.refresh_token;
            if (res) {
              dispatch(setToken({ token }));
              dispatch(setRefreshToken({ refreshToken }));
              dispatch(setAuthDate({ authDate: Date.now() }));
              dispatch(setTokenTime({ tokenTime: res.expires_in }));
              setLoading(false);
            } else {
              // @ts-ignore
              toast.error(res?.message, { theme: "colored" });
              setLoading(false);
            }
          }
        })
        .catch((error) => {
          toast.error(error.data, { theme: "colored" });
          setLoading(false);
        });
    },
    [AuthApi, dispatch],
  );

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-3 text-white-50">
                  <div>
                    <NavLink to="/" className="d-inline-block auth-logo">
                      <img
                        src={logoLight}
                        alt=""
                        style={{ fontSize: "30px", width: "25%", height: "25%" }}
                      />
                    </NavLink>
                  </div>
                  {/*<p className="mt-3 fs-15 fw-medium ">Admin Panel</p>*/}
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-info">{translate("TITTLE_LOGIN_WELCOME_BACK")}</h5>
                      <p className="text-muted">{translate("TITTLE_LOGIN_SIGN_IN_TO")}</p>
                    </div>
                    <Formik
                      onSubmit={(values) => handleAuth(values)}
                      initialValues={initialValues}
                      validationSchema={validationSchema(translate)}
                    >
                      {({ handleSubmit, errors, touched }) => (
                        <div className="p-2 mt-4">
                          <Form onSubmit={handleSubmit}>
                            <div className="mb-3">
                              <Label htmlFor="email" className="form-label">
                                {translate("TITTLE_LOGIN_EMAIL")}
                              </Label>
                              <Field
                                name="username"
                                id="username"
                                className={`form-control ${
                                  touched.username && errors.username ? "required-input" : ""
                                }`}
                                placeholder="Enter email"
                                // type="number"
                              />
                              {touched.username && errors.username ? (
                                <div style={{ color: "red", marginLeft: "5px" }}>
                                  {errors.username}
                                </div>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <div
                                className="float-end opacity-0"
                                onClick={() => history.push(Routes.ForgetPassword)}
                              >
                                <NavLink
                                  to={Routes.ForgetPassword}
                                  className="text-muted"
                                  style={{ cursor: "pointer" }}
                                >
                                  {translate("TITTLE_LOGIN_FORGET_PASSWORD")}
                                </NavLink>
                              </div>
                              <Label className="form-label" htmlFor="password-input">
                                {translate("TITTLE_LOGIN_PASSWORD")}
                              </Label>
                              <div className="position-relative auth-pass-inputgroup mb-3">
                                <Field
                                  name="password"
                                  type={`${!showPassword ? "password" : "text"}`}
                                  className={`form-control pe-5 ${
                                    touched.password && errors.password ? "required-input" : ""
                                  }`}
                                  placeholder="Enter Password"
                                />
                                {touched.password && errors.password ? (
                                  <div style={{ color: "red", marginLeft: "5px" }}>
                                    {errors.password}
                                  </div>
                                ) : null}
                                <button
                                  className="btn btn-link position-absolute end-0 top-0 mt-2 text-decoration-none text-muted"
                                  type="button"
                                  id="password-addon"
                                  onClick={() => setShowPassword((prev) => !prev)}
                                >
                                  {!showPassword ? (
                                    <i className="ri-eye-fill align-middle" />
                                  ) : (
                                    <i className="ri-eye-off-fill align-middle" />
                                  )}
                                </button>
                              </div>
                            </div>

                            <div className="form-check">
                              <Input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id="auth-remember-check"
                              />
                              <Label className="form-check-label" htmlFor="auth-remember-check">
                                {translate("TITTLE_LOGIN_REMEMBER_ME")}
                              </Label>
                            </div>

                            <div className="mt-4">
                              <Button
                                color="info"
                                className="btn btn-info w-100 btn-load"
                                type="submit"
                                disabled={loading}
                              >
                                <span className="d-flex align-items-center">
                                  <span className="flex-grow-1 me-2">
                                    {translate("TITTLE_LOGIN_SIGN_IN")}
                                  </span>
                                  {loading && (
                                    <Spinner size="sm" className="flex-shrink-0" role="status" />
                                  )}
                                </span>
                              </Button>
                            </div>

                            {/*<div className="mt-4 text-center">*/}
                            {/*  <div className="signin-other-title">*/}
                            {/*    <h5 className="fs-13 mb-4 title">Sign In with</h5>*/}
                            {/*  </div>*/}
                            {/*  <div>*/}
                            {/*    <FacebookLogin*/}
                            {/*        appId={facebook.APP_ID}*/}
                            {/*        autoLoad={false}*/}
                            {/*        callback={facebookResponse}*/}
                            {/*        render={renderProps => (*/}
                            {/*            <Button color="primary"*/}
                            {/*                    className="btn-icon me-1"*/}
                            {/*                    onClick={renderProps.onClick}*/}
                            {/*            >*/}
                            {/*              <i className="ri-facebook-fill fs-16" />*/}
                            {/*            </Button>*/}
                            {/*        )}*/}
                            {/*    />*/}
                            {/*    <GoogleLogin*/}
                            {/*        clientId={google.CLIENT_ID}*/}
                            {/*        render={renderProps => (*/}
                            {/*            <Button color="danger"*/}
                            {/*                    to="#"*/}
                            {/*                    className="btn-icon me-1"*/}
                            {/*                    onClick={renderProps.onClick}*/}
                            {/*            >*/}
                            {/*              <i className="ri-google-fill fs-16" />*/}
                            {/*            </Button>*/}
                            {/*        )}*/}
                            {/*        onSuccess={googleResponse}*/}
                            {/*        onFailure={() => {*/}

                            {/*        }}*/}
                            {/*    />*/}
                            {/*    /!* <Button color="primary" className="btn-icon"><i className="ri-facebook-fill fs-16"></i></Button>{" "} *!/*/}
                            {/*    /!* <Button color="danger" className="btn-icon"><i className="ri-google-fill fs-16"></i></Button>{" "} *!/*/}
                            {/*    <Button color="dark" className="btn-icon"><i className="ri-github-fill fs-16"></i></Button>{" "}*/}
                            {/*    <Button color="info" className="btn-icon"><i className="ri-twitter-fill fs-16"></i></Button>*/}
                            {/*  </div>*/}
                            {/*</div>*/}
                          </Form>
                        </div>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
                <div className="d-flex justify-content-end align-items-center">
                  <LanguageDropdown />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
}

export default LoginPage;
